import createReactComponent from '../createReactComponent';
var ThermometerSnowflake = createReactComponent('ThermometerSnowflake', [['path', {
  d: 'M2 12h10',
  key: '19562f'
}], ['path', {
  d: 'M9 4v16',
  key: '81ygyz'
}], ['path', {
  d: 'M3 9l3 3-3 3',
  key: 'hxjjng'
}], ['path', {
  d: 'M12 6L9 9 6 6',
  key: 'sono6m'
}], ['path', {
  d: 'M6 18l3-3 1.5 1.5',
  key: '1l3tbo'
}], ['path', {
  d: 'M18 2a2 2 0 00-2 2v10.5a4 4 0 104 0V4a2 2 0 00-2-2z',
  key: '9b1lt'
}]]);
export default ThermometerSnowflake;